module.exports = __webpack_public_path__ + "img/article-2401903-1B728FE7000005DC-767_634x635.jpg";